import { createMRTColumnHelper, MRT_ColumnDef } from "material-react-table";
import { Bibliography } from "../../types/bibliography";
import {
  EntityWithMetadataTableSuffixColumns,
  createEntityFilterSpec,
  publishedIdColumn,
} from "./EntityUtils";
import type { FilterSpec } from "../../hooks/useServerFilters";

const columnHelper = createMRTColumnHelper<Bibliography>();

const bibliographyColumns: MRT_ColumnDef<Bibliography, any>[] = [
  publishedIdColumn,
  columnHelper.accessor("filename", {
    header: "Filename",
  }),
  columnHelper.accessor("author", {
    header: "Author",
  }),
  columnHelper.accessor("title", {
    header: "Title",
  }),
  columnHelper.accessor("year", {
    header: "Year",
  }),
  columnHelper.accessor("jababo", {
    header: "JABABO",
  }),
  columnHelper.accessor("ardi_id", {
    header: "Ardi ID",
  }),
  ...EntityWithMetadataTableSuffixColumns,
];

export const bibliographyFilterSpec: FilterSpec = createEntityFilterSpec({
  filename: { kind: "string" },
  author: { kind: "string" },
  title: { kind: "string" },
  year: { kind: "string" },
  jababo: { kind: "string" },
  ardi_id: { kind: "string" },
});

export default bibliographyColumns;

